import React, { useEffect, useState } from "react";
import styles from "./MatchScore.module.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MatchInfo from "../../components/MatchInfo/MatchInfo";
import LiveScore from "../../components/LiveScore/LiveScore";
import ScoreCard from "../../components/ScoreCard/ScoreCard";
import Squad from "../../components/Squad/Squad";
import BallbyBall from "../../components/BallbyBall/BallbyBall";
import Commentary from "../../components/Commentary/Commentary";
import Timer from "../../components/Timer/Timer";
import { homeData } from "../../features/home/homeSlice";
import vsImage from "../../assets/images/vs.png";
import { liveScoreData } from "../../features/liveScore/liveScoreSlice";
import demo2 from "../../assets/images/download (1).jpeg";
import Skeleton from "../../components/Skeleton/Skeleton";
import { scoreCardData } from "../../features/scoreCard/scoreCardSlice";

const MatchScore = () => {
  const { match_id, match_status } = useParams();
  console.log(match_status);
  const [matchInfo, setmatchInfo] = useState(true);
  // const [liveScore, setliveScore] = useState(false);
  const [scoreCard, setscoreCard] = useState(false);
  const [squad, setsquad] = useState(false);
  const [ballByBall, setballByBall] = useState(false);
  const [commentary, setcommentary] = useState(false);
  const [matchData, setmatchData] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [firstRender, setfirstRender] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const dispatch = useDispatch();
  const dataHome = useSelector((state) => state.home.data);
  const pendingHome = useSelector((state) => state.home.pending);
  const errorHome = useSelector((state) => state.home.error);
  const finalDataHome = dataHome.data;

  const dataLive = useSelector((state) => state.liveScore.data);
  const pendingLive = useSelector((state) => state.liveScore.pending);
  const errorLive = useSelector((state) => state.liveScore.error);
  const finalDataLive = dataLive.data;

  const dataScorecard = useSelector((state) => state.scoreCard.data);
  const pendingScorecar = useSelector((state) => state.scoreCard.pending);
  const errorScorecar = useSelector((state) => state.scoreCard.error);
  const finalDataScoreCard = dataScorecard.data;

  const handleClick = (name) => {
    switch (name) {
      case "matchInfo":
        setmatchInfo(true);
        setscoreCard(false);
        setsquad(false);
        setcommentary(false);

        break;
      case "liveScore":
        setmatchInfo(false);
        setscoreCard(false);
        setsquad(false);
        setcommentary(false);

        break;

      case "scoreCard":
        setmatchInfo(false);
        setscoreCard(true);
        setsquad(false);
        setcommentary(false);
        break;

      case "squad":
        setmatchInfo(false);
        setscoreCard(false);
        setsquad(true);
        setcommentary(false);
        break;

      case "ballByBall":
        setmatchInfo(false);
        setscoreCard(false);
        setsquad(false);
        setcommentary(false);

        break;

      case "commentary":
        setmatchInfo(false);
        setscoreCard(false);
        setsquad(false);
        setcommentary(true);

        break;

      default:
        setmatchInfo(true);
        setscoreCard(false);
        setsquad(false);
        setcommentary(false);
    }
  };

  useEffect(() => {
    // Update screenWidth when the window is resized
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // dispatch(homeData());
    if (match_status === "Live") {
      const intervalId = setInterval(() => {
        dispatch(liveScoreData(match_id));
      }, 1000);

      return () => clearInterval(intervalId);
      // dispatch(liveScoreData(match_id));
    }
  }, [dispatch]);
  useEffect(() => {
    if (firstRender && !pendingHome) {
      setfirstRender(false);
    }
  }, [pendingHome]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(scoreCardData(match_id));
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  if (errorHome || errorLive) {
    return <div>Error: {errorHome}</div>;
  }

  return (
    <>
      {pendingHome && firstRender  ? (
        <div className={styles.loader}>
          <Skeleton type="liveScoreSkeleton" />
        </div>
      ) : (
        !firstRender && (
          <div className={styles.parentContainer}>
            {/* {console.log(finalDataHome)} */}
            <div className={styles.fixturesHeading}>
              {finalDataHome
                ?.filter((item) => item.match_id === parseInt(match_id))
                ?.map((item, index) => (
                  <div className={styles.slide} key={index}>
                    {/* {console.log(item.match_id, match_id)}
                {console.log(item.match_status)} */}
                    <div className={styles.matchData}>
                      <div className={styles.firstContainer}>
                        <div className={styles.matchInfo}>
                          <p className={styles.teamsName}>
                            {item.team_a} vs {item.team_b}{" "}
                          </p>
                          <p className={styles.seriesName}>{item.series}</p>
                        </div>

                        <p className={item.match_status.toLowerCase() ===
                                      "live"  ? styles.matchStatusLive : styles.matchStatus  }>
                               {item.match_status.toLowerCase() ===
                                      "live"  ? (<div className={styles.liveStatus}><div className={styles.liveRedDot}></div>{item.match_status}</div>) : (<div>{item.match_status}</div>)}
                            </p>
                      </div>
                      <div className={styles.secondContainer}>
                        {(() => {
                          switch (item.match_status.toLowerCase()) {
                            case "live":
                              return (
                                <p className={styles.toss}>
                                  {item.toss ? item.toss : ""}
                                </p>
                              );
                            case "finished":
                              return (
                                <p className={styles.toss}>
                                  {item.result ? item.result : ""}
                                </p>
                              );
                            case "upcoming":
                              return (
                                <div className={styles.startTime}>
                                  <p className={styles.startTimeHeading}>
                                    STARTS IN
                                  </p>
                                  <Timer
                                    timeValue={item.date_time}
                                    key={index}
                                  />
                                </div>
                              );
                            default:
                              return null;
                          }
                        })()}
                      </div>
                      {match_status === "Live" && finalDataLive ? (
                        <div className={styles.mainScoreCardWrapper}>
                          <div className={styles.scoreCardFirstContainer}>
                            <div
                              className={`${styles.battingFlag} ${styles.flag}`}
                            >
                              <img
                                src={
                                  parseInt(finalDataLive?.batting_team) ===
                                  finalDataLive?.team_a_id
                                    ? `https://images.weserv.nl/?url=${item.team_a_img}`
                                    : `https://images.weserv.nl/?url=${item.team_b_img}`
                                }
                                alt="bat"
                              />
                            </div>
                            <div className={styles.battersName}>
                              <div className={styles.batter}>
                                <span className={styles.batter1Name}>
                                 
                                  {finalDataLive?.batsman?.["0"]?.name}
                                </span>
                                <div>
                                  <span className={styles.batterScore}>
                                    {finalDataLive?.batsman?.["0"].run}
                                  </span>
                                  <span>
                                    ({finalDataLive?.batsman?.["0"].ball})
                                  </span>
                                </div>
                              </div>

                              <div className={styles.batter}>
                                <span className={styles.batter2Name}>
                                  {finalDataLive?.batsman?.["1"]?.name}
                                </span>
                                <div>
                                  <span className={styles.batterScore}>
                                    {finalDataLive?.batsman?.["1"]?.run}
                                  </span>
                                  <span>
                                    ({finalDataLive?.batsman?.["1"].ball})
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className={styles.scoreCard}>
                              <div className={styles.card1}>
                                <span className={styles.battingTeamName}>
                                  {parseInt(finalDataLive?.batting_team) ===
                                  finalDataLive?.team_a_id
                                    ? finalDataLive?.team_a_short
                                    : finalDataLive?.team_b_short}{" "}
                                </span>
                                <span className={styles.score}>
                                  {parseInt(finalDataLive?.batting_team) ===
                                  finalDataLive?.team_a_id ? (
                                    <span>
                                      {finalDataLive?.team_a_scores_over[1]
                                        ? finalDataLive?.team_a_scores_over[1]
                                            .score
                                        : finalDataLive?.team_a_scores_over[0]
                                            .score}
                                    </span>
                                  ) : (
                                    <span>
                                      {finalDataLive?.team_b_scores_over[1]
                                        ? finalDataLive?.team_b_scores_over[1]
                                            .score
                                        : finalDataLive?.team_b_scores_over[0]
                                            .score}
                                    </span>
                                  )}
                                </span>

                                <span className={styles.powerPlay}>
                                  P{finalDataLive?.powerplay}
                                </span>
                                <span className={styles.overs}>
                                  {parseInt(finalDataLive?.batting_team) ===
                                  finalDataLive?.team_a_id ? (
                                    <span>
                                      {finalDataLive?.team_a_scores_over[1]
                                        ? finalDataLive?.team_a_scores_over[1]
                                            .over
                                        : finalDataLive?.team_a_scores_over[0]
                                            .over}
                                    </span>
                                  ) : (
                                    <span>
                                      {finalDataLive?.team_b_scores_over[1]
                                        ? finalDataLive?.team_b_scores_over[1]
                                            .over
                                        : finalDataLive?.team_b_scores_over[0]
                                            .over}
                                    </span>
                                  )}
                                </span>
                              </div>

                              <div className={styles.card2}>
                                <span className={styles.target}>
                                  {finalDataLive?.trail_lead !== ""
                                    ? finalDataLive?.trail_lead
                                    : finalDataLive?.target
                                    ? "Target" + " " + finalDataLive?.target
                                    : ""}
                                </span>
                              </div>
                            </div>

                            <div
                              className={`${
                                screenWidth >= 768
                                  ? styles.crrAndrr
                                  : styles.inactive
                              } `}
                            >
                              {finalDataLive.rr_rate &&
                              finalDataLive.rr_rate !== "0.00" ? (
                                <div>
                                  <div>
                                    Current Run Rate :{" "}
                                    {finalDataLive?.curr_rate}
                                  </div>
                                  <div>
                                    Required Run Rate : {finalDataLive?.rr_rate}
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  Current Run Rate : {finalDataLive?.curr_rate}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className={styles.scoreCardSecondContainer}>
                            <div
                              className={`${styles.bowlingFlag} ${styles.flag}`}
                            >
                              <img
                                src={
                                  parseInt(finalDataLive?.balling_team) ===
                                  finalDataLive?.team_a_id
                                    ? `https://images.weserv.nl/?url=${item.team_a_img}`
                                    : `https://images.weserv.nl/?url=${item.team_b_img}`
                                }
                                alt="bowl"
                              />
                            </div>
                            <div className={styles.multiItem}>
                              <div className={styles.bowlerData}>
                                <span className={styles.bowlersName}>
                                  {finalDataLive?.bolwer?.name}
                                </span>
                                <span className={styles.bowlerScore}>
                                  {finalDataLive?.bolwer.wicket}-
                                  {finalDataLive?.bolwer.run}{" "}
                                </span>
                                <span className={styles.bowlerOvers}>
                                  ({finalDataLive?.bolwer.over})
                                </span>
                              </div>

                              <div className={styles.last6Balls}>
                                {console.log(finalDataLive?.last36ball)}
                                <span
                                  className={`${
                                    finalDataLive?.last36ball?.[0] === "4"
                                      ? styles.fourRun
                                      : finalDataLive?.last36ball?.[0] === "6"
                                      ? styles.sixRuns
                                      : finalDataLive?.last36ball?.[0] === "W"
                                      ? styles.wicket
                                      : styles.normalBall
                                  }`}
                                >
                                  {finalDataLive?.last36ball?.[0]}
                                </span>
                                <span
                                  className={`${
                                    finalDataLive?.last36ball?.[1] === "4"
                                      ? styles.fourRun
                                      : finalDataLive?.last36ball?.[1] === "6"
                                      ? styles.sixRuns
                                      : finalDataLive?.last36ball?.[1] === "W"
                                      ? styles.wicket
                                      : styles.normalBall
                                  }`}
                                >
                                  {finalDataLive?.last36ball?.[1]}
                                </span>
                                <span
                                  className={`${
                                    finalDataLive?.last36ball?.[2] === "4"
                                      ? styles.fourRun
                                      : finalDataLive?.last36ball?.[2] === "6"
                                      ? styles.sixRuns
                                      : finalDataLive?.last36ball?.[2] === "W"
                                      ? styles.wicket
                                      : styles.normalBall
                                  }`}
                                >
                                  {finalDataLive?.last36ball?.[2]}
                                </span>
                                <span
                                  className={`${
                                    finalDataLive?.last36ball?.[3] === "4"
                                      ? styles.fourRun
                                      : finalDataLive?.last36ball?.[3] === "6"
                                      ? styles.sixRuns
                                      : finalDataLive?.last36ball?.[3] === "W"
                                      ? styles.wicket
                                      : styles.normalBall
                                  }`}
                                >
                                  {finalDataLive?.last36ball?.[3]}
                                </span>
                                <span
                                  className={`${
                                    finalDataLive?.last36ball?.[4] === "4"
                                      ? styles.fourRun
                                      : finalDataLive?.last36ball?.[4] === "6"
                                      ? styles.sixRuns
                                      : finalDataLive?.last36ball?.[4] === "W"
                                      ? styles.wicket
                                      : styles.normalBall
                                  }`}
                                >
                                  {finalDataLive?.last36ball?.[4]}
                                </span>
                                <span
                                  className={`${
                                    finalDataLive?.last36ball?.[5] === "4"
                                      ? styles.fourRun
                                      : finalDataLive?.last36ball?.[5] === "6"
                                      ? styles.sixRuns
                                      : finalDataLive?.last36ball?.[5] === "W"
                                      ? styles.wicket
                                      : styles.normalBall
                                  }`}
                                >
                                  {finalDataLive?.last36ball?.[5]}
                                </span>
                              </div>
                            </div>

                            <div
                              className={`${
                                screenWidth >= 768 && match_status === "Live"
                                  ? styles.runNeedAndExtras
                                  : styles.inactive
                              } `}
                            >
                              {(finalDataLive?.match_type).toLowerCase() ===
                                "test" &&
                              finalDataLive?.current_inning === "4" &&
                              finalDataLive?.run_need &&
                              finalDataLive?.run_need !== 0 ? (
                                <div>
                                  <div>
                                    Extras :{" "}
                                    {
                                      finalDataScoreCard?.scorecard?.[
                                        finalDataLive?.current_inning
                                      ]?.team?.extras
                                    }
                                  </div>{" "}
                                  <div
                                    className={
                                      styles.runNeedAndBallsLeftContainer
                                    }
                                  >
                                    <div className={styles.runNeed}>
                                      Run Need : {finalDataLive?.run_need}
                                    </div>
                                    <div>|</div>
                                    <div className={styles.ballsLeft}>
                                      Balls left : {finalDataLive?.ball_rem}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  Extras :{" "}
                                  {
                                    finalDataScoreCard?.scorecard?.[
                                      finalDataLive?.current_inning
                                    ]?.team?.extras
                                  }
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        // <div className={styles.scoreWrapper}>

                        // </div>
                        <div className={styles.thirdContainer}>
                          <div className={styles.teamDetails}>
                            <div className={styles.teamLogo}>
                              <img
                                src={`https://images.weserv.nl/?url=${item.team_a_img}`}
                                alt={item.team_a_short}
                              />
                            </div>
                            <div className={styles.teamShortName}>
                              {item.team_a_short}
                            </div>
                            <div className={styles.teamScore}>
                              <LiveScore
                                match_id={item.match_id}
                                team={"team_A"}
                              />
                              {/* <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_a_scores_over.length === 0
                            ? "-"
                            : item.team_a_scores_over[0].score}
                        </p>
                        <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_a_scores_over.length === 0
                            ? "yet to bat"
                            : item.team_a_scores_over[0].over + " over"}
                        </p> */}
                            </div>
                          </div>
                          <div className={styles.vsImage}>
                            <img src={vsImage} alt="" />
                          </div>
                          <div className={styles.teamDetails}>
                            <div className={styles.teamLogo}>
                              <img
                                src={`https://images.weserv.nl/?url=${item.team_b_img}`}
                                alt={item.team_b_short}
                              />
                            </div>
                            <div className={styles.teamShortName}>
                              {item.team_b_short}
                            </div>
                            <div className={styles.teamScore}>
                              <LiveScore
                                match_id={item.match_id}
                                team={"team_B"}
                              />
                              {/* <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_b_scores_over.length === 0
                            ? "-"
                            : item.team_b_scores_over[0].score}
                        </p>
                        <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_b_scores_over.length === 0
                            ? "yet to bat"
                            : item.team_b_scores_over[0].over + " over"}
                        </p> */}
                            </div>
                          </div>
                        </div>
                      )}

                        {finalDataLive?.match_id === parseInt(match_id) ? (<div
                        className={`${
                          screenWidth <= 768 && finalDataLive
                            ? styles.extrasAndRunBallsMobileContainer
                            : styles.inactive
                        } `}
                      >
                        {((finalDataLive?.match_type?.toLowerCase() ===
                          "test" &&
                          finalDataLive?.current_inning === "4") ||
                          (finalDataLive?.match_type?.toLowerCase() !==
                            "test" &&
                            finalDataLive?.current_inning === "2")) &&
                        finalDataLive?.run_need &&
                        finalDataLive?.run_need !== 0 ? (
                          <div>
                            <div>
                              Extras :{" "}
                              {
                                finalDataScoreCard?.scorecard?.[
                                  finalDataLive?.current_inning
                                ]?.team?.extras
                              }
                            </div>{" "}
                            <div
                              className={styles.runNeedAndBallsLeftContainer}
                            >
                              <div className={styles.runNeed}>
                                Run Need : {finalDataLive?.run_need}
                              </div>
                              <div>|</div>
                              <div className={styles.ballsLeft}>
                                Balls left : {finalDataLive?.ball_rem}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className={styles.type2Extras}>
                            <div>
                              Extras :{" "}
                              {
                                finalDataScoreCard?.scorecard?.[
                                  finalDataLive?.current_inning
                                ]?.team?.extras
                              }
                            </div>{" "}
                            <div>|</div>
                            <div> C.R.R : {finalDataLive && finalDataLive?.match_id === parseInt(match_id)? finalDataLive?.curr_rate : ""}</div>
                          </div>
                        )}
                      </div>) : ""}

                      

                      {finalDataLive?.match_id === parseInt(match_id) ? (<div className={styles.fourthContainer}>
                        <div className={styles.favTeam}>
                          <div>Fav Team : {item.fav_team}</div>
                          <div className={styles.teamRates}>
                          <p className={styles.ratesfirstTeam}>
                            {item.min_rate}
                          </p>
                          <p className={styles.ratesSecondTeam}>
                            {item.max_rate}
                          </p>
                        </div>
                          
                        </div>
                        
                        {finalDataLive && finalDataLive.match_id === parseInt(match_id) ? (
                          <div className={styles.otherRates}>
                            {/* {console.log(finalDataLive)} */}

                            <div className={styles.overRates}>
                              {finalDataLive?.s_ovr &&
                              finalDataLive?.s_ovr !== "0" &&
                              finalDataLive?.s_ovr !== null ? (
                                <div className={styles.overRateData}>
                                  <div>{finalDataLive?.s_ovr} Over Runs :</div>{" "}
                                  <div className={styles.min}>
                                    {finalDataLive?.s_min}
                                  </div>{" "}
                                  X{" "}
                                  <div className={styles.max}>
                                    {finalDataLive?.s_max} 
                                  </div>
                                  
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className={styles.overRatesLambi}>
                              {finalDataLive?.lambi_ovr ? (
                                <div className={styles.overRateData}>
                                  <div>
                                    {finalDataLive?.lambi_ovr} Over Runs :
                                  </div>{" "}
                                  <div className={styles.min}>
                                    {finalDataLive?.lambi_min}
                                  </div>{" "}
                                  X{" "}
                                  <div className={styles.max}>
                                    {finalDataLive?.lambi_max}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className={styles.runBallRates}>
                              {finalDataLive?.s_ball !== null &&
                              finalDataLive?.s_ball !== undefined ? (
                                <div className={styles.runBallRatesData}>
                                  {" "}
                                  R X B :{" "}
                                  <div className={styles.run}>
                                    {finalDataLive?.s_run}
                                  </div>{" "}
                                  X{" "}
                                  <div className={styles.balls}>
                                    {finalDataLive?.s_ball}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>) : ("")}

                      
                      {finalDataLive && finalDataLive?.match_id === parseInt(match_id) && finalDataLive?.partnership ? (
                        <div className={styles.fifthContainer}>
                          <div className={styles.partnerShip}>
                            Partnership : {finalDataLive?.partnership?.run}(
                            {finalDataLive?.partnership?.ball})
                          </div>
                          <div className={styles.lastWicket}>
                            {" "}
                            {finalDataLive?.lastwicket?.player ? (
                              <div>
                                Last Wicket :{" "}
                                {finalDataLive?.lastwicket?.player}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                ))}
            </div>

            <div className={styles.fixturesNavigation}>
              <ul className={styles.fixturesNavigationLinks}>
                <button
                  onClick={() => handleClick("matchInfo")}
                  className={
                    matchInfo === true ? styles.activated : styles.deactivated
                  }
                >
                  MATCH INFO
                </button>

                {/* <button
            onClick={() => handleClick("liveScore")}
            className={`${
              match_status === "Live" ? styles.active : styles.inactive
            } ${liveScore === true ? styles.activated : styles.deactivated}`}
          >
            Live Score
          </button> */}
                <button
                  onClick={() => handleClick("scoreCard")}
                  className={`${
                    match_status === "Upcoming"
                      ? styles.inactive
                      : styles.active
                  } ${
                    scoreCard === true ? styles.activated : styles.deactivated
                  }`}
                >
                  SCORECARD
                </button>
                <button
                  onClick={() => handleClick("squad")}
                  className={
                    squad === true ? styles.activated : styles.deactivated
                  }
                >
                  SQUAD
                </button>
                {/* <button
            onClick={() => handleClick("ballByBall")}
            className={`${
              match_status === "Upcoming" ? styles.inactive : styles.active
            } ${ballByBall === true ? styles.activated : styles.deactivated}`}
          >
            BALL BY BALL
          </button> */}
                <button
                  onClick={() => handleClick("commentary")}
                  className={`${
                    match_status === "Upcoming"
                      ? styles.inactive
                      : styles.active
                  } ${
                    commentary === true ? styles.activated : styles.deactivated
                  }`}
                >
                  COMMENTARY
                </button>
              </ul>
            </div>

            <div className={styles.fixtureCardsContainer}>
              {matchInfo && <MatchInfo />}
              {/* {liveScore && <LiveScore />} */}
              {scoreCard && <ScoreCard />}
              {squad && <Squad />}
              {/* {ballByBall && <BallbyBall />} */}
              {commentary && <Commentary />}
            </div>
          </div>
        )
      )}
    </>
  );
};

export default MatchScore;
